import { Outlet } from 'react-router-dom'
import AdminConsoleShell from '../../components/admin/console/shell'

/**
 * SPEC-031 Admin layout — the router entry for `/admin/*`. It renders the
 * `.album-studio`-scoped Studio Console shell ({@link AdminConsoleShell}) around
 * the active admin surface (`<Outlet/>`). The shell owns the left nav, top-bar
 * breadcrumb + ⌘K, static-mode detection (D3), and the toast host; the `Admin`
 * role guard is applied by the router's `AuthGuard` wrapper.
 */
export default function AdminLayout(): JSX.Element {
  return (
    <AdminConsoleShell>
      <Outlet />
    </AdminConsoleShell>
  )
}
